import api from "../api";
export default {
  namespaced: true,
  state: {
    plans: {}
  },
  getters: {
    
  },
  actions: {
    async get_plans({ commit }) {
      try {
        //api.get("/v1/subscriber-plans")
          api.get("/v1/plans")
          .then((res) => {
            commit("GET_PLANS", res.data);
          })
          .catch((error) => {
            commit("ERROR_PLAN", "Erro ao carregar os planos");
          })
          .finally(() => (
            // this.loading = false
            console.log('login request end')
          ));
      } catch (e) {
        commit("ERROR_PLAN", e);
      }
    },
    async cancel_subscription({ commit }, user_id){
      try {
        api.post("/v1/subscriber-plans/cancel", {user_id: user_id})
          .then((res) => {
            location.reload();
          })
          .catch((error) => {
            commit("ERROR_PLAN", "Nao foi possivel cancelar o plano");
          })
          .finally(() => (
            // this.loading = false
            console.log('')
          ));
      } catch (e) {
        commit("ERROR_PLAN", "Nao foi possivel cancelar o plano");
      }
    }, 
    
  
  },
  mutations: {
    GET_PLANS(state, data) {
      state.plans = data
    },
    ERROR_PLAN(state, data) {
      console.log(data)
    }
  }
}